import { post } from '../utils/api';
import { encodeURIIfNeeded, getImageAspectRatio, getVideoAspectRatio } from '../utils';
export const shots = ['照片', '定镜拍摄', '推拉拍摄', '平移拍摄', '其他拍摄方式'];

export function getProductFields() {
    return [
        ['1018', '产品型号'],
        ['1025', '产品规格'],
        ['1009', '产品功能'],
        ['1010', '产品材质'],
        ['1011', '应用领域']
    ];
}

export function getDisplayUrl(url, type, width = 320) {
    return encodeURIIfNeeded(url) + (
        type === 'image'
            ? `?x-oss-process=image/resize,w_${width}`
            : `?x-oss-process=video/snapshot,t_1000,ar_auto,w_${width},h_0,m_fast`
    );
}

export function shuffle(arr) {
    let index = -1, length = arr.length;
    while (++index < length) {
        const ran = Math.min(length - 1, Math.floor(Math.random() * (length - index) + index));
        const val = arr[ran];
        arr[ran] = arr[index];
        arr[index] = val;
    }
}

export async function autoClip(efc, video) {
    if (efc.repeat && !video) {
        return;
    }
    const aspectRatio = efc.width / efc.height;
    let ret;
    const process = (w, h) => {
        const cropWidth = Math.min(w, h * aspectRatio);
        const cropHeight = cropWidth / aspectRatio;

        return {
            x: (w - cropWidth) / 2,
            y: (h - cropHeight) / 2,
            w: cropWidth,
            h: cropHeight
        };
    };

    if (video) {
        await getVideoAspectRatio(efc.src, video => {
            const w = video.videoWidth;
            const h = video.videoHeight;
            ret = process(w, h);

            console.log(ret);
        });

        return ret;
    }
    await getImageAspectRatio(efc.src, img => {
        const w = img.naturalWidth;
        const h = img.naturalHeight;
        ret = process(w, h);
    });

    return ret;
}

const canvas = document.createElement('canvas');
const loadedFonts = {};

function processDetect(font) {
    const context = canvas.getContext('2d');
    if (loadedFonts[font]) {
        return true;
    }
    if (font.toLowerCase() === 'courier new') {
        return true;
    }

    context.font = `30px ${font},'Courier New'`;
    const { width } = context.measureText('anything');
    context.font = `30px 'Courier New'`;
    const { width: otherWidth } = context.measureText('anything');

    const ret = width !== otherWidth;

    if (ret) {
        loadedFonts[font] = 1;
    }

    return ret;
}

function generateDetectFont(fontFamily, lookup) {
    console.log('detecting: ' + fontFamily);
    const detected = processDetect(fontFamily);
    const ret = {};
    ret.promise = new Promise(resolve => {
        if (detected) {
            resolve(true);
        } else {
            try {
                const url = lookup && lookup[fontFamily];
                if (url) {
                    const ft = new FontFace(fontFamily, `local(${fontFamily}),url('/assets/fonts/${url}')`);
                    ft.load().then(() => {
                        console.log(ft.status);
                        document.fonts.add(ft);
                        resolve();
                        loadedFonts[fontFamily] = true;
                    });
                } else {
                    throw new Error('url is required');
                }
            } catch (e) {
                console.log(e);
                ret.timer = setTimeout(() => {
                    const { promise, timer } = generateDetectFont(fontFamily);
                    ret.timer = timer;
                    resolve(promise);
                }, 1e3);
            }
        }
    });

    return ret;
}

export function detectFont(fontFamily, lookup) {
    const obj = generateDetectFont(fontFamily, lookup);

    return Promise.race([obj.promise, new Promise((_, reject) => {
        setTimeout(() => {
            if (obj.timer) {
                clearTimeout(obj.timer);
            }
            reject(new Error('an error occurred'));
        }, 1e5);
    })]);
}

export function parseSceneId(sid) {
    return [].concat(sid || []).join(',').split(',');
}

const seriesTemplateLookup = {};

export async function loadSeriesTemplates() {
    const {
        data: { list, template },
        t_thirdid,
        thirdName
    } = await post('series/product/series-template-params', {
        id: Object.keys(seriesTemplateLookup)
    });

    Object.assign(seriesTemplateLookup, template);

    return {
        templates: list.map(item => {
            const curTemplate = JSON.parse(JSON.stringify(seriesTemplateLookup[item.id]));
            return Object.assign(curTemplate, item);
        }),
        t_thirdid,
        thirdName
    };
}